import React from 'react';
import Logo from '../components/Logo';

export default function BrandingPage() {
  return (
    <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#0b1423] px-6">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[min(80vw,600px)] w-[min(80vw,600px)] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#3fc0fa]/10 blur-[100px]" />
      <div className="relative flex flex-col items-center gap-7 text-center">
        <Logo size="lg" />
        <span className="h-px w-24 bg-gradient-to-r from-transparent via-[#3fc0fa]/60 to-transparent" />
        <p className="text-xs font-semibold uppercase tracking-[0.35em] text-slate-400">Jelly Local</p>
      </div>
    </main>
  );
}